import React, { useEffect } from 'react';

// The canonical Terms of Service now lives at /terms-of-service.html — a standalone
// HTML/CSS/JS page (required to be publicly accessible without JS rendering for
// A2P 10DLC campaign verification). This route redirects for backward compatibility.
const TermsOfService: React.FC = () => {
  useEffect(() => {
    window.location.replace('/terms-of-service.html');
  }, []);

  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center">
      <p className="text-text-secondary">
        Redirecting to our{' '}
        <a href="/terms-of-service.html" className="text-gold-500 hover:text-gold-400 underline">
          Terms of Service
        </a>
        …
      </p>
    </div>
  );
};

export default TermsOfService;
